import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import WizardServerError from '../../../../model/WizardServerError';

import { ModularListingContext } from '../../../../containers/CreateListingPage/context';
import { WizardContext } from '../../../Wizard/context';

import { DISPLAY_SERVER_ERROR_AT } from '../../../../constants/WizardConstants';

import { useForm } from '../../../../hooks';
import PropertyConstants from '../../../../constants/PropertyConstants';
import { postingConstraints } from '../../../../utils/formValidation';
import PropertiesActions from '../../../../actions/PropertiesActions';
import actions from '../../../../containers/CreateListingPage/actions';
import wizardActions from '../../../Wizard/actions';
import EditPropertyType from '../../../EditPropertyType';
import WizardAlert from '../../../WizardAlert';

const propTypes = {
  closeModal: PropTypes.func.isRequired,
};
const defaultProps = {};

const inputName = 'propertyType';

const PropertyTypeFormField = ({ closeModal }) => {
  const dispatch = useDispatch();

  const { reducerWizardDispatch } = useContext(WizardContext);
  const {
    modularListingState: { isInModalState, isSaveComplete, serverErrorObj, shouldSaveOnBlur },
    reducerDispatch,
  } = useContext(ModularListingContext);
  const { propertyType, listingAlias } = useSelector((state) => state.properties.currentProperty);

  const {
    inputs,
    hasFieldError,
    handleChange: handleFormChange,
  } = useForm(
    {
      propertyType,
    },
    postingConstraints,
  );

  useEffect(() => {
    if (isSaveComplete) {
      // eslint-disable-next-line no-use-before-define
      save({
        target: {
          name: inputName,
          value: inputs.propertyType,
        },
      });
    }
  }, [isSaveComplete]);

  const clearServerError = () => {
    if (serverErrorObj.fieldName) {
      actions.removeServerError({
        reducerDispatch,
      });
    }
  };

  const save = (event) => {
    // return if user must click on cta
    if (!shouldSaveOnBlur && !isSaveComplete) {
      return;
    }

    const { value, name: fieldName } = event.target;

    if (hasFieldError(fieldName, value)) {
      return;
    }

    wizardActions.updateIsFetchingData({ reducerWizardDispatch, isFetchingData: true });

    dispatch(
      PropertiesActions.updatePropertyType({
        propertyId: listingAlias,
        propertyTypeCode: PropertyConstants.PROPERTY_CODES_BY_TYPE[inputs.propertyType],
      }),
    )
      .then(() => {
        dispatch(
          PropertiesActions.updateCurrentProperty({
            [fieldName]: value,
            properyTypeCode: PropertyConstants.PROPERTY_CODES_BY_TYPE[inputs.propertyType],
          }),
        );

        // reset save cta
        actions.updateIsSaveComplete({ reducerDispatch, isSaveComplete: false });
      })
      .catch((message) => {
        updateServerError(message, fieldName);
      })
      .finally(() => {
        wizardActions.updateIsFetchingData({
          reducerWizardDispatch,
          isFetchingData: false,
        });
      });
  };

  const updateServerError = (message = '', fieldName = '') => {
    const displayAt = isInModalState ? DISPLAY_SERVER_ERROR_AT.FIELD : DISPLAY_SERVER_ERROR_AT.PAGE;

    actions.updateServerError({
      reducerDispatch,
      serverErrorObj: WizardServerError({
        displayAt,
        fieldName,
        message,
        displayMessage: message,
      }),
    });
  };

  const handleChange = (event) => {
    clearServerError();
    handleFormChange(event);
  };

  return (
    <div data-test="PropertyTypeFormField">
      <WizardAlert serverErrorObj={serverErrorObj} displayAt={DISPLAY_SERVER_ERROR_AT.FIELD} />
      <EditPropertyType
        onConvertComplete={closeModal}
        correctPropertyType={inputs.propertyType}
        onSelectChange={handleChange}
      />
    </div>
  );
};

PropertyTypeFormField.propTypes = propTypes;
PropertyTypeFormField.defaultProps = defaultProps;

export default PropertyTypeFormField;
